<!-- DASHBOARD PAGE -->
<template>
  <div class="assets">
    <v-card>
      <v-card-text>
        <div class="d-flex flex-column" style="height: 100%">
          <mission-asset-metrics
            @click-metric="onMetricsClick"
            ref="metrics"
          />
          <v-row class="flex-grow-1">
            <v-col cols="6">
              <mission-asset-table
                style="-webkit-overflow-scrolling: touch"
                @select="selectMissionAsset"
                @fetch="(items) => (missionAssets = items)"
                @filter="onTableFilter"
                ref="table"
              />
            </v-col>

            <v-col cols="6">
              <mission-asset-map
                :mission-assets="missionAssets"
                :map-height="250"
                :handle-feature-click="selectMissionAssetByFeature"
                ref="map"
              />
              <mission-asset-detail
                :mission-asset-id="missionAssetSelected.id"
                v-if="missionAssetSelected"
              />
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { formatDateLocal } from "@/helpers/dates";
import { FirmService } from "@/services/firm.service";
import MissionAssetMap from "@/components/MissionAsset/MissionAssetMap";
import MissionAssetMetrics from "@/components/MissionAsset/MissionAssetMetrics";
import MissionAssetTable from "@/components/MissionAsset/MissionAssetTable";
import MissionAssetDetail from "@/components/MissionAsset/MissionAssetDetail";

export default {
  props: {
    metric: {
      type: String,
    },
  },
  components: {
    MissionAssetMap,
    MissionAssetMetrics,
    MissionAssetTable,
    MissionAssetDetail,
  },
  data: () => ({
    missionAssets: [],
    missionAssetSelected: null,
    assessmentPeriod: null,
    filters: {},
  }),
  computed: {
    ...mapState({
      config: (state) => state.config.config,
    }),
    metricsParams() {
      return {
        // We need the service type because if only an assessment_period_end value
        // is filled in then the user *may* be looking for unfinished missions.
        // @todo - use vuex directly instead of using this.$data.filters.
        service_type: this.filters.serviceType,
        assessment_period_start: this.filters.serviceDateStart
          ? formatDateLocal(
              moment(this.filters.serviceDateStart).startOf("month"),
              ""
            )
          : undefined,
        assessment_period_end: this.filters.serviceDateEnd
          ? formatDateLocal(
              moment(this.filters.serviceDateEnd).endOf("month"),
              ""
            )
          : undefined,
      };
    },
  },
  mounted() {
    // 2021-06-15
    // Component currently tightly coupled with MissionAssetTable,
    // MissionAssetTableFilter and MissionAssetMetrics because
    // they all share filters via vuex. Comparable missions
    // components are also sharing the same filters too.
    // (filter component ultimately triggers fetching)
  },
  methods: {
    selectMissionAsset(missionAsset = null) {
      this.missionAssetSelected = missionAsset;
      this.$refs.map.selectFeatureByMissionAsset(missionAsset);
    },
    selectMissionAssetByFeature(feature) {
      // Convert feature to mission asset
      const missionAsset = this.missionAssets.find(
        (missionAsset) => missionAsset.coreId === feature.properties.asset_id
      );
      this.$refs.table.$refs.baseTable.selectItem(missionAsset);
    },
    onMetricsClick(metric) {
      // Disabled. We now update vuex in the metrics component.
    },
    onTableFilter(filters) {
      this.filters = filters;
      this.$nextTick(() => {
        // 2021-06-11
        // The metrics now automatically respond when filters in vuex change.
        // this.$refs.metrics.fetchMetrics();
      });
    },
  },
};
</script>

<style lang="scss">
.assets {
  height: 100%;
  .v-card {
    height: 100%;
    .v-card__text {
      height: 100%;
    }
  }
}
</style>
